/**
 * @module directives/media/play-on-hover
 */

/**
 * Play video on hover.
 */
export default function playOnHoverDirective() {
  document.querySelectorAll('[data-sw-play-on-hover]').forEach(element => {
    element.addEventListener('mouseenter', _ => {
      element.querySelectorAll('video').forEach(video => {
        if (!video.ended || video.loop) video.play();
      });
    });
    element.addEventListener('mouseleave', _ => {
      element.querySelectorAll('video').forEach(video => {
        video.pause();
      });
    });
  });
}



// WEBPACK FOOTER //
// ./source/scripts/directives/media/play-on-hover.js